export { default as FreeSlider } from './FreeSlider.vue';
